import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MetadataUpdater = ({ routeMetadata }) => {
    const location = useLocation();

    useEffect(() => {
        const metadata = routeMetadata[location.pathname] || {
            title: "Evoluz by Farmagitech",
            description: "This page is currently under maintenance. Please check back later.",
        };

        // Update the document title
        document.title = metadata.title;

        // Update or create meta description tag
        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute("content", metadata.description);
        } else {
            const newMetaDescription = document.createElement("meta");
            newMetaDescription.name = "description";
            newMetaDescription.content = metadata.description;
            document.head.appendChild(newMetaDescription);
        }
    }, [location, routeMetadata]);

    return null;
};

export default MetadataUpdater;
